import React, { useState, useEffect } from "react";
import { FaArrowRight } from "react-icons/fa";
import { supabase } from "../../supabaseClient"; // Supabase bağlantımızı import ediyoruz
import "./BlogSection.scss";

// Statik blogPostsData dizisini siliyoruz.

// BlogPostCard component'ini export ettiğimizden emin olalım
export const BlogPostCard = ({ image, date, title, excerpt, url }) => {
  return (
    <div className="blog-card">
      <div className="blog-card__image-wrapper">
        <img src={image} alt={title} className="blog-card__image" />
        <div className="blog-card__date-ribbon">
          <span>{date}</span>
        </div>
      </div>
      <div className="blog-card__content">
        <h3 className="blog-card__title">{title}</h3>
        <p className="blog-card__excerpt">{excerpt}</p>
        <a href={url} className="blog-card__read-more-btn">
          Daha Fazlasını Gör <FaArrowRight />
        </a>
      </div>
    </div>
  );
};

const BlogSection = () => {
  // 1. State'leri oluşturuyoruz
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 2. useEffect ile verileri çekiyoruz
  useEffect(() => {
    const fetchLatestPosts = async () => {
      setLoading(true);

      const { data, error } = await supabase
        .from("posts")
        .select("*")
        .eq("category", "Pati Hikayeleri")
        .order("created_at", { ascending: false })
        .limit(3); // Sadece en son 3 yazıyı getir

      if (error) {
        console.error("Error fetching latest posts:", error);
        setError(error.message);
      } else {
        setPosts(data);
      }

      setLoading(false);
    };

    fetchLatestPosts();
  }, []);

  // 3. Yüklenme ve hata durumlarını yönetiyoruz
  if (loading) {
    return (
      <div className="blog-section-container">
        <div className="page-container">
          <p>Son yazılar yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="blog-section-container">
        <div className="page-container">
          <p>Yazılar yüklenirken bir hata oluştu.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-section-container">
      <div className="blog-grid">
        {posts.map((post) => (
          <BlogPostCard
            key={post.id}
            image={post.image_url}
            date={new Date(post.created_at).toLocaleDateString("tr-TR", {
              day: "numeric",
              month: "long",
            })}
            title={post.title}
            excerpt={post.excerpt}
            url={`/pati-hikayeleri/${post.slug}`}
          />
        ))}
      </div>
    </div>
  );
};

export default BlogSection;
